export default function Logo(props){

    return(
        <div className="px-2" style={{minWidth: `${parseInt(100 / props.imagesPerRow)}%`,
                                                height: 140}}>
            <div className="logo-container border rounded-md border-slate-300 p-3 flex items-center h-full">
                <img className={`image-item`}
                     src={props.src} alt={`Slide ${props.index}`} key={props.index}
                     style={{width: "100%", height: "auto", maxHeight: "90%"}}/>
            </div>
        </div>

    )
}